import { useEffect, useState } from 'react';
import { apiFetch } from './apiFetch';
import { getApiUrl } from './api';

const API_URL = getApiUrl();
const INACTIVE = Object.freeze({ active: false, provider: '', environment: '' });

export function useFiscalAvailability({ enabled, sessionKey, isSessionCurrent }) {
  const [confirmed, setConfirmed] = useState({ sessionKey: null, feature: INACTIVE });

  useEffect(() => {
    const controller = new AbortController();
    setConfirmed({ sessionKey, feature: INACTIVE });
    if (!enabled || !sessionKey || !isSessionCurrent()) return () => controller.abort();

    const load = async () => {
      try {
        const response = await apiFetch(`${API_URL}/api/settings/fiscal/availability`, {
          cache: 'no-store', signal: controller.signal,
        });
        const data = await response.json().catch(() => ({}));
        if (controller.signal.aborted || !isSessionCurrent()) return;
        if (!response.ok) throw new Error('Disponibilidade fiscal indisponível.');
        const provider = String(data.provider || '').trim().toLowerCase();
        const environment = String(data.environment || '').trim().toLowerCase();
        setConfirmed({
          sessionKey,
          feature: {
            active: data.active === true && provider === 'sefaz_direct' && environment === 'homologation',
            provider, environment,
          },
        });
      } catch (_) {
        if (!controller.signal.aborted && isSessionCurrent()) {
          setConfirmed({ sessionKey, feature: INACTIVE });
        }
      }
    };
    void load();
    return () => controller.abort();
  }, [enabled, sessionKey, isSessionCurrent]);

  return enabled && confirmed.sessionKey === sessionKey && isSessionCurrent() ? confirmed.feature : INACTIVE;
}
